import React from 'react';

import { useTranslation } from '@modernloop/i18n';

import { AtsType } from 'src/generated/mloop-graphql';

import { getAtsService, useOrgAtsService } from 'src/hooks/atsService';

type Props = {
  atsType?: AtsType;
};

/**
 * Renders the ATS-specific plural label for scorecards.
 */
const AtsScorecardName = ({ atsType }: Props) => {
  const { t } = useTranslation();
  const currentAtsService = useOrgAtsService();

  // If an ATS Type is provided, use that
  if (atsType) {
    return <>{t(getAtsService(atsType).scorecardLabelPluralTranslationKey)}</>;
  }
  // If org is connected to an ATS, use that
  if (currentAtsService) {
    return <>{t(currentAtsService.scorecardLabelPluralTranslationKey)}</>;
  }
  return <>{t('hiring-dashboard-common:common.ats.scorecardsFallback')}</>;
};

export default AtsScorecardName;
